<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      :title="detail.name"
      :z-index="10"
      @click-left="onBack"></van-nav-bar>
    <div class="contain">
      <div class="detailContain">
        <div class="d-info-images">
          <van-list v-for="(imageUrl, index) in imgDetailUrls" :key="index">
            <img class="d-image" :src="imageUrl" alt="详情图片" fit="cover" />
          </van-list>
        </div>
      </div>
      <div class="bottom-bg">
        <van-button class="btn" type="danger" @click="onBuy"
          >立即认购</van-button
        >
      </div>
    </div>
  </div>
</template>
  
  <script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
  <script>
import * as ProductApi from "@/api/product"
import { List } from "vant"
import { mapGetters } from "vuex"
export default {
  name: "detail-productdesc",
  components: {
    [List.name]: List
  },
  data() {
    return {
      detail: {},
      imgDetailUrls: []
    }
  },
  computed: {
    ...mapGetters(["channel", "userInfo"])
  },
  mounted() {
    this._showLoading()
    ProductApi.productCustomUrl(this.$route.query.productId)
      .then((data) => {
        this._dismissLoading()
        this.detail = data
        if (data.imgDetailUrl) {
          this.imgDetailUrls = data.imgDetailUrl.split(",")
        }
      })
      .catch((e) => {
        this._dismissLoading()
        this.$toast(e.msg || e.message)
      })
  },
  created() {
    setTimeout(() => {
      wx.hideAllNonBaseMenuItem()
    }, 1000)
  },
  destroyed() {
    wx.showAllNonBaseMenuItem()
  },
  methods: {
    onBack() {
      this.$router.replace({
        path: "/home",
        query: { chanlCode: this.channel }
      })
      // goableBack()
    },
    onBuy() {
      this.$router.replace({
        path: "/detail",
        query: { productId: this.detail.id, isProductdescPush: true }
      })
    }
  }
}
</script>
  
  <style lang="less" scoped>
html,
body {
  line-height: 0;
}
.contain {
  .detailContain {
    margin-bottom: 44px;
    .d-info-images {
      width: 100vw;
      margin: 0;
      padding: 0;
      .d-image {
        width: 100%;
        padding: 0;
        margin: 0;
      }
    }
  }
  .bottom-bg {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    height: 44px;
    .btn {
      border: none;
      border-radius: 0;
      width: 100%;
      height: 100%;
      background-color: rgb(222, 189, 141);
      color: white;
      font-size: 18px;
      letter-spacing: 1px;
    }
  }
}
</style>
  